import { Plugin } from './Plugin';
import { Scene } from '../objects';
import { customization, storage } from 'storage';
import { Box3, DoubleSide } from 'three';


export class ScenePlugin extends Plugin{
	constructor(manager){
		super(manager);

		this.scene = null;

		this._floor = null;
		this._wall = null;
	}

	attach(){
		customization.on('customization-loaded', this.onCustomizationLoaded);
	}

	detach(){
		customization.off('product-added', this.onProductAdded);
		customization.off('product-modified', this.onProductAdded);
		customization.off('product-removed', this.onProductRemoved);
		customization.off('customization-loaded', this.onCustomizationLoaded);
	}

	onProductAdded = (code) => {
		const {product} = customization.products.get(code);

		const floorTileId = 25;
		const wallTileId = 28;
		switch(product.entity.entity_type_id){
			case floorTileId:
				this.setFloor(product);
				break;
			case wallTileId:
				this.setWall(product);
				break;
		}
	}

	onProductRemoved = (code) => {
		const type = storage.getEntityTypeByCode(code);

		const floorTileId = 25;
		const wallTileId = 28;
		switch(type.id){
			case floorTileId:
				this.setFloor(null);
				break;
			case wallTileId:
				this.setWall(null);
				break;
		}

	}

	onCustomizationLoaded = () => {
		customization.off('product-added', this.onProductAdded);
		customization.off('product-modified', this.onProductAdded);
		customization.off('product-removed', this.onProductRemoved);
		customization.products.forEach((value, key) => {
			this.onProductAdded(key);
		})
		customization.on('product-added', this.onProductAdded);
		customization.on('product-modified', this.onProductAdded);
		customization.on('product-removed', this.onProductRemoved);
	}

	setFloor(floor){
		if(this._floor != floor){
			this._floor = floor;
			this.updateScene();
		}
	}

	setWall(wall){
		if(this._wall != wall){
			this._wall = wall;
			this.updateScene();
		}
	}

	updateScene(){

		if(this._floor && this._wall){

			const model = customization.scene.models.find(m => m.pivot.floor_id == this._floor.id && m.pivot.wall_id == this._wall.id);

			if(model){
				const scene = new Scene(this.viewer, model.filename, customization.scene);


				this.waitSet(scene);
				const setup = () => {
					scene.removeEventListener('loaded', setup);
	                this.set(scene);
					this.viewer.requestRender();
				};

				if(!scene.loaded){
					scene.addEventListener('loaded', setup);
				}
				else setup();
			}
		}
	}

	waitSet(scene){

		const setup = () => {
			scene.removeEventListener('loaded', setup);
            this.set(scene);
			this.viewer.requestRender();
		};

		if(!scene.loaded){
			scene.addEventListener('loaded', setup);
		}
		else setup();
	}

	set(scene){

		if(this.scene){
			this.viewer.remove(this.scene);
			this.scene.freeMemory();
		}
		if(scene){

			this.scene = scene;
			this.viewer.add(scene);

			scene.traverse(obj => {
				obj.receiveShadow = true;
				obj.castShadow = true;
				if(obj.isMesh){
					obj.material.side = DoubleSide;
					if(obj.material.name.toLowerCase().startsWith('verre')){
						obj.castShadow = false;
					}
				}
			})

			if(!customization.scene || this._previousScene != customization.scene.slug){
				if(customization.scene){
					this._previousScene = customization.scene.slug;

					scene.setDefaultView();

				}
				this.emit('scene-changed', scene);
			}
			else{
				this.emit('scene-updated', scene);
			}
		}
	}


}